import Base from './base';
import { ANALYTICS_EVENTS } from '../constants/analyticsEvents';

export default class Settings extends Base {
  search(params) {
    window.analytics.track(ANALYTICS_EVENTS.SEARCH, params);
    return this.apiClient.get('/search', params);
  }
}
